export default __webpack_public_path__ + "static/ui-dashboard-d8dfb91a682d80c26e9e42418b488186.png";